/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/search-modal');
require('./main/breadcrumbs');
require('./main/search-window');
require('./main/search-results-page');
require('./main/quick-nav');
require('./campus-tabs');
require('./findstr');

import domReady from '@wordpress/dom-ready';

domReady(() => {
  console.log('Dom is ready');
});
